export const enum ValueChanger {
  app = "app",
  api = "api",
  user = "user",
}
